module.exports = __webpack_public_path__ + "img/Sales Icon - charcoal.625b5c3a.svg";